import React, { useState } from "react";
import { Dialog } from "@headlessui/react";

import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import SelectMenu from "../../controls/SelectMenu";
import Button from "../../controls/Button";

export default function DeleteReceivingItemByBarcodeForm(props) {
  const { barcodeOptions, confirmAction, setOpen } = props;
  const [inputValue, setInputValue] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const closeModal = () => {
    if (isLoading) return;
    setOpen({ childComponent: null, open: false });
  };

  const onSubmit = async () => {
    if (isLoading) return;
    if (inputValue === null) {
      setError("Please select a barcode");
      return;
    }

    setIsLoading(true);
    setOpen((prev) =>
      prev && typeof prev === "object"
        ? { ...prev, preventClose: true }
        : prev,
    );
    try {
      await Promise.resolve(confirmAction(inputValue.value));
    } finally {
      setIsLoading(false);
      setOpen((prev) =>
        prev && typeof prev === "object"
          ? { ...prev, preventClose: false }
          : prev,
      );
    }
  };

  return (
    <div>
      <div>
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
          <ExclamationCircleIcon
            className="h-11 w-11 text-red-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-base font-normal leading-6 text-gray-800 family-didact"
          >
            Scan barcode to delete
          </Dialog.Title>
          <div className="mt-2">
            <SelectMenu
              menuPortalTarget={document.body}
              handleInputChange={(e) => setInputValue(e.target.value)}
              name="supplier_selected"
              options={barcodeOptions}
              value={inputValue}
              title={"Select barcode"}
              error={error}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center sm:grid sm:grid-flow-row-dense sm:grid-cols-2 gap-3">
        <div className="col-span-1 text-right">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 ring-1 ring-inset ring-gray-300 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={closeModal}
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-1">
          <Button
            type="button"
            variant="danger"
            className="w-fit font-light family-didact"
            onClick={onSubmit}
            loading={isLoading}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
}
